import {DeviceActivityType} from "@models";
import {Injector} from "@angular/core";
import {EventEmitterService} from "./global-event-emitter.service";
import {SimDeviceService, SystemHub} from "@services";
import {defer, Observable} from "rxjs";
import {Params} from "@angular/router";
import {tap} from "rxjs/operators";

/**
 *
 * Subscribes to a group in the system hub
 * @param topic The topic to subscribe to
 * @param routeParamKey The key of the route params to use as the topic id
 * @param injector
 */
export function subscribeToGroup(topic: DeviceActivityType, routeParamKey: string, injector: Injector) {
	const systemHub = injector.get(SystemHub);
	const eventEmitter = injector.get(EventEmitterService);
	const deviceService = injector.get(SimDeviceService);

	let hasSubscribed = false;
	let topicId: string;

	const reconnectionSubscription = eventEmitter.onSystemHubReconnected.subscribe(() => systemHub.addToGroup(topic, topicId).then());

	return (source: Observable<Params>) =>
		defer(() =>
			source.pipe(
				tap({
					next: (params) => {
						topicId = params[routeParamKey];
						if (hasSubscribed) {
							return;
						}
						hasSubscribed = true;

						systemHub.addToGroup(topic, topicId).then(() => {
							return deviceService.readyToCommunicate(topic);
						});
					},
					complete: () => {
						reconnectionSubscription.unsubscribe();
						systemHub.removeFromGroup(topic, topicId).then();
					},
				}),
			),
		);
}
